import en_US from './en_US.json'
import es_MX from './es_MX.json'
import de_DE from './de_DE.json'
import fr_FR from './fr_FR.json'
import zh_CN from './zh_CN.json'
import pt_BR from './pt_BR.json'

export { en_US, es_MX, de_DE, fr_FR, zh_CN, pt_BR }
